module.exports = __webpack_public_path__ + "static/media/hazard-certainty.42d085da.svg";